import type { GameManual } from '../../types';
import { voidfallChapters, voidfallFirstGame } from './content';

export const voidfallManual: GameManual = {
  chapters: voidfallChapters,
  firstGameSteps: voidfallFirstGame,
  addons: [],
};

export * from './content';
export * from './blockers';
export * from './faq';
export * from './glossary';
export * from './guided';
export * from './quickReference';
export * from './commonMistakes';
export * from './scoring';
export * from './components';
export * from './icons';
export * from './search';
export * from './validate';
